import LocalStorageCookieBasedAuthHttpInterceptor from 'core/auth/LocalStorageCookieBasedAuthHttpInterceptor';
import { setHttpInterceptor } from 'core/http/HttpService';
import { text2moment, unix2moment } from 'core/utils';

class CustomHttpInterceptor
    extends LocalStorageCookieBasedAuthHttpInterceptor {
  constructor() {
    super();
  }

  getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) {
      return parts.pop().split(";").shift();
    }
    return undefined;
  }

  secondsToSessionExpiration() {
    const cookie = this.getCookie('TOC');
    if (!cookie) {
      return undefined;
    }
    const now = unix2moment(new Date().getTime() / 1000);
    const expiration = text2moment(cookie);
    return Math.floor(expiration.diff(now) / 1000);
  }

  isLoggedAsync(to) {
    console.log('isLoggedAsync');
    console.log('\tthis', this);
    console.log('\tto', to);

    if (to.matched.some(record => record.meta.requiresAuth)) {
      console.log('This routes requires authentication');
      // this route requires auth, check if logged in
      // if not, redirect to login page.
      if (!this.loggedIn) {
        console.log('User is not authenticated');
        return Promise.reject();
      } else {
        console.log('User seems authenticated');
        const missingSeconds = this.secondsToSessionExpiration();
        console.log('missingSeconds', missingSeconds);
        if (!missingSeconds || missingSeconds <= 0) {
          console.log('Session is expired');
          return Promise.reject();
        }
        return Promise.resolve();
      }
    } else {
      console.log('This routes does not require authentication');
      return Promise.resolve();
    }
  }

}

const interceptor = new CustomHttpInterceptor();

setHttpInterceptor(interceptor);

export default interceptor;
